// Two-letter initials: first letters of the first two words, else first two chars.
export function initials(name?: string | null): string {
  if (!name) return '?'
  const words = name.trim().split(/\s+/)
  const raw = words.length > 1 ? words[0][0] + words[1][0] : name.slice(0, 2)
  return raw.toUpperCase()
}
